<ng-container *transloco="let t; read: 'incoming-chat-waiting-room'">
  <div class="d-flex justify-content-center">
    <p *ngIf="isNextInLine" class="text-center">{{ t('nextInLineMessage') }} {{ t('doNotRefresh') }}</p>
    <p *ngIf="!isNextInLine" class="text-center">{{ t('body', { queuePosition }) }} {{ t('doNotRefresh') }}</p>
  </div>
  <div class="d-flex justify-content-end">
    <button
      *ngIf="redirectURL"
      class="p-button-raised p-button-help"
      icon="pi pi-sign-out"
      iconPos="left"
      pButton
      type="button"
      label="{{ t('exitButton') }}"
      (click)="redirectNow()"
    ></button>
  </div>
</ng-container>
